import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "bootstrap-icons/font/bootstrap-icons.css";
import './App.css';
//import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from './logo.svg';
//import Swal from "sweetalert2";
//import { toast, ToastContainer } from "react-toastify";
//import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Login";
import Register from "./Register";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Banks from "./pages/Banks";
import Buyers from "./pages/Buyers";
import Despatcho from "./pages/Despatcho";
import Ports from "./pages/Ports";
import Redex from "./pages/Redex";
import Shipping from "./pages/Shipping";
import Supplier from "./pages/Supplier";
import Material from "./pages/Material";
import Transporter from "./pages/Transporter";
import StudentDetails from "./pages/StudentDetails";
import StudentEdit from "./pages/StudentEdit";
import Courses from "./pages/Courses";
import Settings from "./pages/Settings";
import Ledgers from "./pages/Ledgers";
import Summary from "./pages/Summary";
import DangerZone from "./pages/DangerZone";
import BankStatement from "./pages/BankStatement";

function App() {
  return (
  <>
    <BrowserRouter>

      <Routes>
	  
	  {/* Login */}
        <Route path="/" element={<Login />} />
		<Route path="/register" element={<Register />} />

        {/* Protected Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
		  <Route path="banks" element={<Banks />} />
		  <Route path="buyers" element={<Buyers />} />
		  <Route path="despatcho" element={<Despatcho />} />
		  <Route path="ports" element={<Ports />} />
		  <Route path="redex" element={<Redex />} />
		  <Route path="shipping" element={<Shipping />} />
		  <Route path="supplier" element={<Supplier />} />
		  <Route path="material" element={<Material />} />
		  <Route path="transporter" element={<Transporter />} />
		  <Route path="ledger" element={<Ledgers />} />
		  <Route path="summary" element={<Summary />} />
		  <Route path="bank/statement" element={<BankStatement />} />
		  <Route path="student/:id" element={<StudentDetails />} />
		  <Route path="editstudent/:id" element={<StudentEdit/>} />
		  <Route path="settings" element={<Settings />} />
		  <Route path="restricted" element={<DangerZone />} />
		  
        </Route>

      </Routes>

    </BrowserRouter>
	
	  </>
  );
}

export default App;